import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { EMPTY, of } from 'rxjs';
import { LeadService } from 'src/app/services/lead.service';
import { GetGenderOptionsRequestAction, GetGenderOptionsResponseAction, SaveDetailsRequestAction, SaveDetailsResponseAction, SetDetailsErrorAction, UpdateDetailsFieldRequestAction, UpdateDetailsFieldResponseAction } from './actions';
import { GenderService } from 'src/app/services/gender.service';

@Injectable()
export class NmjDetailsEffects {
  constructor(private store: Store<any>,
    private actions$: Actions,
    private service: LeadService,
    private genderService:GenderService) {
  }

  updateNextPage$ = createEffect(() => this.actions$.pipe(
    ofType(SaveDetailsRequestAction),
    switchMap((action: any) => this.service.update(action.step, action.field, action.data).pipe(
      map((data: any) => {
        this.service.showOk(data.message);
        return SaveDetailsResponseAction();
      }),
      catchError(_err => {
        return of(SetDetailsErrorAction());
      })
    )),
  ));

  updateDetailsField$ = createEffect(() => this.actions$.pipe(
    ofType(UpdateDetailsFieldRequestAction),
    switchMap((action: any) => this.service.update(action.step, action.field, action.data).pipe(
      map((data: any) => {
        this.service.showOk(data.message);
        return UpdateDetailsFieldResponseAction();
      }),
      catchError(_err => {
        return of(SetDetailsErrorAction());
      })
    )),
  ));

  getGenderOptions$ = createEffect(() => this.actions$.pipe(
    ofType(GetGenderOptionsRequestAction),
    switchMap((_action: any) => this.genderService.getGenderList().pipe(
      map((data: any) => {
        return GetGenderOptionsResponseAction({genders:data.data});
      }),
      catchError(_err => {
        return EMPTY;
      })
    )),
  ));

}
